// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "wrapper-2z0_M";
var _5 = "container-6DcW-";
var _6 = "card-Xlps_";
var _7 = "content-3fpex";
var _8 = "footer-196fv";
var _9 = "button-2lZER";
var _a = "modal_scrollBody-2vizt";
var _b = "modal_paper-1eYlF";
var _c = "modal_recovery_paper-3CX9o";
var _d = "modal_connect_paper-2MJ6K";
var _e = "menu-1C8he";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "wrapper", _5 as "container", _6 as "card", _7 as "content", _8 as "footer", _9 as "button", _a as "modal_scrollBody", _b as "modal_paper", _c as "modal_recovery_paper", _d as "modal_connect_paper", _e as "menu" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "wrapper": _4, "container": _5, "card": _6, "content": _7, "footer": _8, "button": _9, "modal_scrollBody": _a, "modal_paper": _b, "modal_recovery_paper": _c, "modal_connect_paper": _d, "menu": _e }
